
























































































































































































































































































































































































































































































































































































































































































































































































import {
  defineComponent,
  useContext,
  useRouter,
  ref,
  useFetch,
  useRoute,
  computed,
} from "@nuxtjs/composition-api";
import {
  TrackingOrderLists,
  useUserOrder,
} from "~/modules/customer/composables/useUserOrder";
import SkeletonLoader from "~/components/SkeletonLoader/index.vue";
import { convertTime } from "~/helpers/index";
import { copyCode, getLabelColorBySku } from "~/helpers";
import { Order, useUiNotification } from "~/composables";
import useMakeOrder from "~/modules/checkout/composables/useMakeOrder";
import {
  getVariantImage,
  getVariantName,
  getUrlQuery,
  getBgColorValue,
  getColorLabel,
  getSizeLabel,
  getPrice,
} from "~/modules/checkout/helpers";
import { useOderStore } from "~/modules/checkout/stores/oder";
import TrackingInfo from "~/modules/customer/pages/MyAccount/OrderHistory/SingleOrder/TrackingInfo.vue";

export default defineComponent({
  name: "SingleOrderNew",
  components: {
    TrackingInfo,
    SkeletonLoader,
  },
  props: { orderId: { type: String } },
  setup(props) {
    const { app } = useContext();
    const router = useRouter();
    const route = useRoute();
    const oderStore = useOderStore();
    const { send: sendNotification } = useUiNotification();
    const { getOrderData, loading } = useMakeOrder();
    const { customerTrackingOrder } = useUserOrder();

    const productConfiguration = ref(route.value?.params);
    const incrementId = productConfiguration.value?.orderId
      ? (productConfiguration.value.orderId as string).split("-")[0]
      : props.orderId || "";

    const orderData = ref<Order>(null);
    const orderItems = computed(() => {
      return orderData.value?.order_items || [];
    });
    const orderInfo = computed(() => {
      return orderData.value?.order_info || null;
    });

    const orderDiscounts = computed(() => {
      return (
        orderInfo.value?.order_discounts?.filter(
          (discount) => discount.voucher_amount && discount.voucher_amount > 0
        ) || []
      );
    });

    const totalItems = computed(() => {
      return orderItems.value?.reduce((total, item) => {
        if (item?.qty_ordered && item?.qty_ordered > 0) {
          return total + item?.qty_ordered;
        }
        return total;
      }, 0);
    });

    const totalPrice = computed(() => {
      return orderItems.value?.reduce((total, item) => {
        if (item?.original_price && item?.qty_ordered > 0) {
          return total + item?.qty_ordered * item?.original_price;
        }
        return total;
      }, 0);
    });

    const discountItems = computed(() => {
      return orderItems.value?.reduce((total, item) => {
        if (
          item?.original_price &&
          item?.price > 0 &&
          item?.original_price > item?.price &&
          item?.qty_ordered > 0
        ) {
          return (
            total + (item?.original_price - item?.price) * item?.qty_ordered
          );
        }
        return total;
      }, 0);
    });

    const saveMoney = computed(() => {
      return (
        (Math.abs(orderInfo.value?.discount_amount) || 0) +
        (orderInfo.value?.loyalty_amount || 0) +
        (discountItems.value || 0)
      );
    });

    const paymentValue = ref("");
    const trackingOrderData = ref<TrackingOrderLists[]>(null);
    const currentStatus = ref("");
    const classOrderStatus = ref("");
    const classOrderStatusMobile = ref("");
    const descriptionMobile = ref("");
    const classOrderDataDetail = ref("");

    useFetch(async () => {
      orderData.value = await getOrderData(incrementId);
      paymentValue.value = orderInfo.value?.payment_method;

      const params = {
        order_code: incrementId,
      };
      const resultTrackingOrder = await customerTrackingOrder(params);
      if (resultTrackingOrder && Array.isArray(resultTrackingOrder.data)) {
        trackingOrderData.value = resultTrackingOrder.data
          .filter((item) => item?.create_date && item.create_date !== "")
          .reverse();
      } else {
        trackingOrderData.value = [];
      }
      classOrderDataDetail.value =
        trackingOrderData.value?.[0]?.order_status ||
        orderData.value?.order_info?.status ||
        "";
      if (
        classOrderDataDetail.value &&
        classOrderDataDetail.value == "pending"
      ) {
        classOrderDataDetail.value = "Pending";
      }

      const orderStatus = trackingOrderData.value?.find(
        (item) => item.current_status
      )?.order_status;

      switch (orderStatus) {
        case "Created":
          classOrderStatus.value = "order-detail__status--processing";
          currentStatus.value = "Đang xử lý";
          classOrderStatusMobile.value = "processing";
          descriptionMobile.value = "Đơn hàng đang được tiếp nhận";
          break;
        case "Validated":
          classOrderStatus.value = "order-detail__status--processing";
          currentStatus.value = "Đang xử lý";
          classOrderStatusMobile.value = "processing";
          descriptionMobile.value = "Đơn hàng đang được chuẩn bị";
          break;
        case "To be Prepared":
          classOrderStatus.value = "order-detail__status--processing";
          currentStatus.value = "Đang vận chuyển";
          classOrderStatusMobile.value = "processing";
          descriptionMobile.value = "Đã giao cho đơn vị vận chuyển";
          break;
        case "Ready for pickup":
        // Thanh toán tại cửa hàng
        case "Prepared":
          classOrderStatus.value = "order-detail__status--shipping";
          currentStatus.value = "Đang vận chuyển";
          classOrderStatusMobile.value = "shipping";
          descriptionMobile.value = "Đơn hàng đang trên đường giao";
          break;
        case "Package given to carrier":
          classOrderStatus.value = "order-detail__status--delivered";
          currentStatus.value = "Đã giao";
          classOrderStatusMobile.value = "delivered";
          descriptionMobile.value = "Giao hàng thành công";
          break;
        case "Cancel":
          classOrderStatus.value = "order-detail__status--cancel";
          currentStatus.value = "Đã hủy";
          descriptionMobile.value = "Đơn hàng của bạn đã hủy";
          classOrderStatusMobile.value = "cancel";
          break;
      }

      if (
        orderInfo.value?.status === "pending" &&
        orderInfo.value?.payment_method !== "cashondelivery"
      ) {
        classOrderStatus.value = "order-detail__status--waiting";
        currentStatus.value = "Chờ thanh toán";
        classOrderStatusMobile.value = "waiting";
        descriptionMobile.value = "Đơn hàng đang chờ thanh toán";
      }
    });

    const getPercent = (originalPrice: number, price: number) => {
      return 100 - Math.round((price / originalPrice) * 100);
    };

    const configSku = (sku: string) => {
      return sku.split("-");
    };

    const back = () => {
      if (window.history.length > 1) {
        window.history.back();
      } else {
        router.push("/customer/order-history");
      }
    };

    const isMore = ref(false);
    const isTracking = ref(false);

    const handleCopyCode = (code: string) => {
      copyCode(code);
      let message = `Bạn đã copy mã ${code}`;
      sendNotification({
        id: Symbol("copy_text_success"),
        message: message,
        type: "success",
        icon: "check",
        persist: false,
        title: message,
      });
    };

    const updatePaymentMethod = async () => {
      try {
        const result = await oderStore.changePayment(
          incrementId,
          paymentValue.value
        );

        if (result && result?.status == 1) {
          return true;
        } else {
          sendNotification({
            id: Symbol("update_payment_error"),
            message: "Cập nhật phương thức thanh toán thất bại",
            type: "info",
            icon: "error",
            persist: false,
          });
          return false;
        }
      } catch (error) {
        console.error("Error setting payment method:", error);
      }
    };

    const payment = async () => {
      if (paymentValue.value === "cashondelivery") {
        if (paymentValue.value === orderInfo.value?.payment_method) {
          return;
        }
        const isChanged = await updatePaymentMethod();
        if (!isChanged) return;
        const paymentOder = app.localeRoute({
          name: "orderdetailpayonline",
          query: {
            increment_id: incrementId,
            method: paymentValue.value,
            status: "success",
          },
        });
        await router.push(paymentOder);
      } else {
        if (paymentValue.value !== orderInfo.value?.payment_method) {
          const isChanged = await updatePaymentMethod();
          if (!isChanged) return;
        }
        const paymentOder = app.localeRoute({
          name: "orderdetailpayonline",
          query: {
            increment_id: incrementId,
            method: paymentValue.value,
            status: "pending",
          },
        });
        await router.push(paymentOder);
      }
    };

    const isChangePaymentMethod = ref(false);
    const handleChangePaymentMethod = () => {
      isChangePaymentMethod.value = !isChangePaymentMethod.value;
    };

    const paymentMethodCurrent = computed(() => {
      const paymentMethod = orderInfo.value?.payment_method;
      switch (paymentMethod) {
        case "cashondelivery":
          return "Thanh toán khi nhận hàng (COD)";
        case "vnpay":
          return "Thẻ ATM/Visa/Master/JCB/QR Pay qua cổng VNPAY";
        case "shopee_pay":
          return "Thanh toán bằng ShopeePay";
        default:
          return "";
      }
    });

    const getStatusClass = (status, payment_method) => {
      switch (status) {
        case "Created":
          return "order-detail__status--processing";
        case "Validated":
        case "To be Prepared":
          return "order-detail__status--processing";
        case "Prepared":
          return "order-detail__status--shipping";
        case "Package given to carrier":
        case "complete":
          return "order-detail__status--delivered";
        case "Cancel":
          return "order-detail__status--cancel";
        case "Pending":
          if (payment_method !== "cashondelivery") {
            return "order-detail__status--waiting";
          } else {
            return "order-detail__status--processing";
          }
        default:
          return "";
      }
    };

    const getStatusName = (status, payment_method) => {
      switch (status) {
        case "Created":
          return "Đang xử lý";
        case "Validated":
        case "To be Prepared":
          return "Đang xử lý";
        case "Prepared":
          return "Đang vận chuyển";
        case "Package given to carrier":
          return "Đã giao";
        case "Cancel":
          return "Đã hủy";
        case "Pending":
          if (payment_method !== "cashondelivery") {
            return "Chờ thanh toán";
          } else {
            return "Đang xử lý";
          }
        default:
          return "";
      }
    };

    return {
      orderNumber: incrementId,
      orderData,
      orderInfo,
      orderItems,
      back,
      convertTime,
      paymentValue,
      getPercent,
      getVariantImage,
      getVariantName,
      getUrlQuery,
      getBgColorValue,
      getColorLabel,
      getSizeLabel,
      getPrice,
      configSku,
      isMore,
      handleCopyCode,
      payment,
      isChangePaymentMethod,
      handleChangePaymentMethod,
      isTracking,
      trackingOrderData,
      classOrderStatus,
      currentStatus,
      classOrderStatusMobile,
      descriptionMobile,
      paymentMethodCurrent,
      loading,
      totalItems,
      discountItems,
      totalPrice,
      classOrderDataDetail,
      getStatusClass,
      getStatusName,
      getLabelColorBySku,
      saveMoney,
      orderDiscounts,
    };
  },
});
